/// <reference no-default-lib="true" />
/// <reference lib="esnext" />
/// <reference lib="dom" />

export function initIconToggles() {
  const iconToggles = Array.from(document.querySelectorAll('.icon__toggle'))

  for (const iconToggle of iconToggles) {
    if (!(iconToggle instanceof HTMLElement)) {
      continue
    }
    if (iconToggle.dataset.hydrated) continue
    iconToggle.dataset.hydrated = 'true'

    iconToggle.addEventListener('toggle', () => {
      const current = iconToggle.getAttribute('data-icon-toggle') || 'default'

      if (current === 'default') {
        iconToggle.setAttribute('data-icon-toggle', 'toggle')
      } else {
        iconToggle.setAttribute('data-icon-toggle', 'default')
      }
    })

    iconToggle.addEventListener('toggle-default', () => {
      iconToggle.setAttribute('data-icon-toggle', 'default')
    })

    iconToggle.addEventListener('toggle-toggle', () => {
      iconToggle.setAttribute('data-icon-toggle', 'toggle')
    })
  }
}
